import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Database, Eye, UserCheck, Clock, Lock, Mail } from 'lucide-react';

export const PolitiqueConfidentialite = () => (
    <div className="min-h-screen bg-sand" data-testid="politique-confidentialite-page">
        <div className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-jungle/60 hover:text-jungle mb-8 transition-colors" data-testid="back-home-link">
                <ArrowLeft className="w-4 h-4" /> Retour a l'accueil
            </Link>

            <h1 className="font-heading font-bold text-3xl sm:text-4xl text-jungle mb-10">Politique de Confidentialite</h1>

            <p className="text-jungle/60 text-sm mb-10">Derniere mise a jour : Mars 2026</p>

            <div className="space-y-10 text-jungle/80 text-sm leading-relaxed">
                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Shield className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">1. Responsable du traitement</h2>
                    </div>
                    <div className="pl-7 space-y-1">
                        <p>PRIXDEAL, dont le siege social est situe au CENTRA 307, 94586 RUNGIS CEDEX, est responsable du traitement des donnees personnelles collectees sur le site prix-deal.fr.</p>
                        <p><strong>Contact DPO :</strong> contact@prix-deal.fr</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Database className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">2. Donnees collectees</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Dans le cadre de notre activite B2B, nous collectons les donnees suivantes :</p>
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>Donnees d'identification :</strong> nom, prenom, raison sociale, SIRET</li>
                            <li><strong>Coordonnees :</strong> adresse email, numero de telephone, adresse postale</li>
                            <li><strong>Donnees de commande :</strong> historique des commandes, demandes de prix, preferences produits</li>
                            <li><strong>Donnees de connexion :</strong> adresse IP, donnees de navigation, cookies</li>
                        </ul>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Eye className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">3. Finalites du traitement</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Les donnees collectees sont utilisees pour :</p>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>La gestion et le suivi des commandes et demandes de prix</li>
                            <li>La creation et la gestion du compte client</li>
                            <li>La communication d'offres commerciales personnalisees</li>
                            <li>L'amelioration de nos services et de notre plateforme</li>
                            <li>Le respect de nos obligations legales et comptables</li>
                            <li>L'analyse statistique de la frequentation du site</li>
                        </ul>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <UserCheck className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">4. Base legale du traitement</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Le traitement de vos donnees repose sur :</p>
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>L'execution du contrat :</strong> pour la gestion des commandes et la relation commerciale</li>
                            <li><strong>L'interet legitime :</strong> pour l'amelioration de nos services et la prospection commerciale B2B</li>
                            <li><strong>Le consentement :</strong> pour les cookies non essentiels et les communications marketing</li>
                            <li><strong>L'obligation legale :</strong> pour la conservation des factures et documents comptables</li>
                        </ul>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Clock className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">5. Duree de conservation</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>Donnees clients actifs :</strong> pendant toute la duree de la relation commerciale</li>
                            <li><strong>Donnees clients inactifs :</strong> 3 ans apres le dernier contact</li>
                            <li><strong>Donnees de facturation :</strong> 10 ans (obligation legale)</li>
                            <li><strong>Cookies :</strong> 13 mois maximum</li>
                        </ul>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Lock className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">6. Securite des donnees</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>PRIXDEAL met en oeuvre les mesures techniques et organisationnelles appropriees pour proteger vos donnees personnelles contre tout acces non autorise, toute modification, divulgation ou destruction.</p>
                        <p>Les donnees sont transmises de maniere chiffree (HTTPS) et stockees sur des serveurs securises.</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <UserCheck className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">7. Vos droits</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Conformement au RGPD, vous disposez des droits suivants :</p>
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>Droit d'acces :</strong> obtenir une copie de vos donnees personnelles</li>
                            <li><strong>Droit de rectification :</strong> corriger des donnees inexactes</li>
                            <li><strong>Droit a l'effacement :</strong> demander la suppression de vos donnees</li>
                            <li><strong>Droit a la limitation :</strong> restreindre le traitement de vos donnees</li>
                            <li><strong>Droit a la portabilite :</strong> recevoir vos donnees dans un format structure</li>
                            <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos donnees</li>
                        </ul>
                        <p>Pour exercer ces droits, contactez-nous a : <strong>contact@prix-deal.fr</strong></p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Database className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">8. Cookies</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Notre site utilise des cookies pour :</p>
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>Cookies essentiels :</strong> necessaires au fonctionnement du site (authentification, panier)</li>
                            <li><strong>Cookies analytiques :</strong> mesure d'audience et amelioration du site</li>
                        </ul>
                        <p>Vous pouvez gerer vos preferences de cookies via le bandeau de consentement affiche lors de votre premiere visite.</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Mail className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">9. Contact et reclamation</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Pour toute question relative a la protection de vos donnees, vous pouvez nous contacter a <strong>contact@prix-deal.fr</strong>.</p>
                        <p>Si vous estimez que le traitement de vos donnees n'est pas conforme, vous pouvez adresser une reclamation a la CNIL (Commission Nationale de l'Informatique et des Libertes) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-leaf hover:underline">www.cnil.fr</a></p>
                    </div>
                </section>
            </div>

            <div className="mt-12 pt-8 border-t border-jungle/10 flex flex-wrap gap-4 text-xs text-jungle/50">
                <Link to="/mentions-legales" className="hover:text-jungle transition-colors">Mentions legales</Link>
                <Link to="/cgv" className="hover:text-jungle transition-colors">CGV</Link>
            </div>
        </div>
    </div>
);
